module.exports = __webpack_public_path__ + "assets/img/b4-10.3fe06d63.png";